import { render, staticRenderFns } from "./previewFile.vue?vue&type=template&id=87862d66&scoped=true"
import script from "./previewFile.vue?vue&type=script&lang=js"
export * from "./previewFile.vue?vue&type=script&lang=js"
import style0 from "./previewFile.vue?vue&type=style&index=0&id=87862d66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87862d66",
  null
  
)

export default component.exports